export * from './Newspaper';
